import { StyledCol } from '@/shared/styles';
import { AccessibilityScore } from './AccessibilityScore/AccessibilityScore';
import { AccessibilityIssues } from './AccessibilityIssues/AccessibilityIssues';

export const ScanResults: React.FC = () => {
  return (
    <StyledCol $gap={32}>
      <AccessibilityScore />
      <AccessibilityIssues />
    </StyledCol>
  );
};
